import React from 'react';
import styled from 'styled-components';

/**
 *
 * Plain Modal, use to have full control over content style, note that className and style props will be applied to the content div
 * and not to the root wrapper
 *
 */

const ReusableModalPlain = ({ children, wrapperStyle, style, className }: Props) => (
	<ModalWrapper style={wrapperStyle}>
		{/* Note: forwarding className here to allow styled components to work */}
		<ModalContent style={style} className={className}>
			{children}
		</ModalContent>
	</ModalWrapper>
);

export default ReusableModalPlain;

interface Props {
	children: React.ReactNode;
	style?: React.CSSProperties;
	wrapperStyle?: React.CSSProperties;
	className?: string;
}

const ModalWrapper = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
	background-color: white;
	border-radius: 5px;
`;
